import { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { Accordion } from '@/components/layouts/Ir/Mpocket/Accordion'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const MeetingPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/config-utils-main.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main.js')
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Shareholder's Meeting"
        subTitleText="株主総会"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <Accordion
        id="irp-library-category5"
        className="irp-library-category irp-library-category-5"
      />
    </Layout>
  )
}

MeetingPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主、投資家向け情報', path: '/ir' },
    { name: '株式情報', path: '/ir/stock' },
    { name: '株主総会', path: '' },
  ]

  return (
    <>
      <Head
        title="株主総会"
        description="トライアルホールディングスの株主総会の招集通知や決議通知等を掲載しています。"
        ogp={{ url: 'ir/stock/meeting' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
